/** A atualização só é publicada depois que /me confirma a persistência. */
export const EVENTO_DE_PREFERENCIAS = 'dv:preferencias-salvas'
